export { default, default as TagNew, colorMapping } from './tag-new';
export type { TagNewProps, NewTagColor } from './tag-new';

export { default as AvatarTag } from './avatar-tag';
export type { AvatarTagProps, AvatarRenderProps, TypesOfAvatars } from './avatar-tag';
